export default __webpack_public_path__ + "static/media/WIBS_dark.19c25d50.png";